import styled, { css } from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: calc(100%);
  padding: 2rem;
  padding-bottom: 0rem;
  gap: 1rem;
  background: #f3f4f6;
`;
export const Title = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 3rem;
  max-width:700px;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1.3rem;
  margin-top: 1.75rem;
  font-weight: bolder;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  > span {
    position: absolute;
    display: flex;
    width: 5rem;
    height: 5rem;
    top: -35px;
    left: 1rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffff;
    background-color: #1D86FF;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px
  }
  > div {
    margin-left: 5rem;
  }
`;
export const Button = styled.button`
  outline: none;
  border: none;
  display: flex;
  width: 10rem;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background-color: #1D86FF;
  color: #ffffff;
  font-size: 14px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  &:hover{
    opacity: 0.9;
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.2rem;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  overflow: hidden;
  .filters-bar {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: .5rem;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-right: .5rem;

    .uFN {
      flex: 1;
      min-width: 15vw;
      max-width: 40vw;
      border-radius: 6px;
      background: transparent;
      border: solid 1px #d1d5db;
      transition: all 0.2s ease-in-out;
      &:hover {
        border-color: #9ca3af;
      }
      &:focus-within {
        border-color: #1D86FF;
        box-shadow: 0 0 0 3px rgba(29, 134, 255, 0.2);
      }
    }

    .filters-controls {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-shrink: 0;

      .check-- {
        display: flex;
        align-items: center;
        gap: 0.4rem;

        .check--label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #4b5563;
          white-space: nowrap;
          user-select: none;
          cursor: pointer;
        }
      }

      .filter-divider {
        width: 1px;
        height: 1.25rem;
        background-color: #d1d5db;
        flex-shrink: 0;
      }

      .filter-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        span {
          font-size: 0.9rem;
          font-weight: 500;
          color: #4b5563;
          white-space: nowrap;
        }
      }

      .uFS {
        min-width: 10vw;
        max-width: 20vw;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #ffffff;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        padding: 0.35rem 2rem 0.35rem 0.75rem;
        font-size: 0.9rem;
        color: #374151;
        cursor: pointer;
        outline: none;
        transition: all 0.2s ease-in-out;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 0.5rem center;
        background-size: 0.875rem;

        &:hover {
          border-color: #9ca3af;
        }

        &:focus {
          border-color: #1D86FF;
          box-shadow: 0 0 0 3px rgba(29, 134, 255, 0.2);
        }
      }
    }
  }
  transition: all 0.33s;
`;
export const TutorialsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-right: 0.5rem;
  
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const TutorialCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

export const TutorialHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  background-color: #f9fafb;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f3f4f6;
  }

  .title-group {
    display: flex;
    align-items: center;
    gap: 1rem;

    h3 {
      font-size: 1rem;
      font-weight: 600;
      color: #374151;
      margin: 0;
    }

    span {
      font-size: 0.75rem;
      background-color: #e5e7eb;
      color: #4b5563;
      padding: 0.2rem 0.5rem;
      border-radius: 9999px;
      font-weight: 500;
      text-transform: uppercase;
    }
  }

  .expand-btn {
    background: transparent;
    border: none;
    color: #6b7280;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }
`;

export const TutorialContent = styled.div`
  padding: 1rem;
  border-top: 1px solid #e5e7eb;
  
  > p {
    font-size: 0.875rem;
    color: #6b7280;
    margin-bottom: 1rem;
  }
`;

export const TutorialUsersList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;

  .header {
    display: flex;
    justify-content: space-between;
    font-size: 0.75rem;
    font-weight: 600;
    color: #9ca3af;
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }

  .user-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    color: #4b5563;
    padding: 0.35rem 0;
    border-top: 1px solid #f3f4f6;

    .status {
      font-size: 0.75rem;
      padding: 0.15rem 0.5rem;
      border-radius: 4px;
      font-weight: 500;

      &.pending {
        background-color: #fef3c7;
        color: #92400e;
      }
      &.progressing {
        background-color: #dbeafe;
        color: #1e40af;
      }
      &.finished {
        background-color: #d1fae5;
        color: #065f46;
      }
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  background-color: #ffffff;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  
  th {
    background-color: #f9fafb;
    color: #374151;
    font-weight: 600;
    padding: 1rem;
    border-bottom: 1px solid #e8e8e8;
  }
  
  td {
    padding: 1rem;
    border-bottom: 1px solid #e8e8e8;
    color: #4b5563;
    font-size: 0.875rem;
    vertical-align: top;
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  tr:hover {
    background-color: #f3f4f6;
  }
`;

export const StatusBadge = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-weight: 500;
  display: inline-block;

  ${({ status }) => {
    switch (status) {
      case 'pending':
        return css`
          background-color: #fef3c7;
          color: #92400e;
        `;
      case 'progressing':
        return css`
          background-color: #dbeafe;
          color: #1e40af;
        `;
      case 'finished':
        return css`
          background-color: #d1fae5;
          color: #065f46;
        `;
      default:
        return css`
          background-color: #e5e7eb;
          color: #4b5563;
        `;
    }
  }}
`;

export const TutorialItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f3f4f6;
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  
  .tutorial-title {
    font-weight: 500;
    margin-right: 1rem;
  }
`;
